export default {
    of: 'of',
    back: 'Back',
    filtered: 'Filtered',
    willDownloadOnly: 'Only will download',
    teacherProfile: 'Teacher Profile',
    filterBy: 'Filter by',
    selectOneOrSeveral: 'Select one or several to filter.',
    noResultsFor: 'No results found for',
    planLevel: 'Plan Level',
    number: 'No.',
    minimum: 'Minimum',
    confirmationRequired: 'Confirmation Required',
    areYouSureClose: 'Are you sure you want to close? Unsaved data will be lost.',
    yesClose: 'Yes, close',
    completitudeAbbr: 'PMD COMPLETENESS',
    reportOf: 'REPORT OF',
    formativeMap: 'FORMATIVE MAP',
    linkTo: 'Link {object} to {entity}',
    updatedPlural: 'updated.',
    expandRow: 'Expand row',
    collapseRow: 'Collapse row',
    expandAllRows: 'Expand all rows',
    collapseAllRows: 'Collapse all rows',
    showAllItems: 'Show the {count} items in this column',

    // ========== CompetenceUnitForm ==========
    details: 'Details',
    weighing: 'Weighing',
    equivalentWeighing: 'Equivalent weighing',
    canAddName: 'You can add a name to the {entity}.',
    specifyPercentage: 'Specify the contribution percentage for the {entity}.',
    canSpecifyPosition: 'You can specify the position or order.',
    useEquivalentWeighing: 'Use an equivalent weighing for the {entity}',
    availableWeighingIs: 'The available weighing is',
    requiredFieldMaxPercent: 'This field is required and must not exceed {percent}%.',
    created: 'created.',
    updated: 'updated.',

    // ========== RAMacroForm ==========
    areYouSureDelete: 'Are you sure you want to delete it?',
    deleted: 'deleted.',

    // ========== AI Reports ==========
    evolutiveReportTitle: 'Evolutionary–Comparative Analysis of {entity}',
    evolutiveButtonText: 'Evolutionary Analysis {entity}',
    evolutiveButtonTooltip: 'Analyze coherence, progression and contribution mapping of {entity} with AI',
    improvementReportTitle: 'Improvement Proposal for {entity}',
    improvementButtonText: 'Improvement Proposal {entity}',
    improvementButtonTooltip: 'Generate improvement proposal for {raEntity} and contribution mapping with AI',
}
